import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { mountPleasantConfig } from "./data";

export default function MountPleasantPage() {
  return <CityPageTemplate config={mountPleasantConfig} />;
}